export default __webpack_public_path__ + "static/media/devices_icon.a29ccfb6.svg";